import { Action, createReducer, on } from '@ngrx/store';
import * as LocaleActions from './locale.actions';

export const localeFeatureKey = 'locale';

export interface State {
  locales: any;
  defaultLocale: string;
  appKeyValues: any;
  processLoading: number;
}

export const initialState: State = {
  locales: null,
  defaultLocale: null,
  appKeyValues: null,
  processLoading: 0,
};

export const reducer = createReducer(
  initialState,

  on(LocaleActions.loadLocales, (state) => ({
    ...state,
    processLoading: state.processLoading + 1,
  })),
  on(LocaleActions.loadLocalesSuccess, (state, { data }) => ({
    ...state,
    locales: data,
    processLoading: state.processLoading - 1,
  })),
  on(LocaleActions.loadLocalesFailure, (state, action) => ({
    ...state,
    processLoading: state.processLoading - 1,
  })),
  on(LocaleActions.loadAppKeyValues, (state) => ({
    ...state,
    processLoading: state.processLoading + 1,
  })),
  on(LocaleActions.loadAppKeyValuesSuccess, (state, { data }) => ({
    ...state,
    appKeyValues: data,
    defaultLocale: state.defaultLocale ??  data.DEFAULT_LOCALE,
    processLoading: state.processLoading - 1,
  })),
  on(LocaleActions.loadAppKeyValuesFailure, (state, action) => ({
    ...state,
    processLoading: state.processLoading - 1,
  })),
  on(LocaleActions.loadDefaultLocale, (state, action) => ({
    ...state,
    defaultLocale: action.locale,
  }))
);
